<template>
  <div class="mainNew">
    <div class="topTitle">
      <span style="font-family:'PingFangBold';color:#333333;font-size: 16px;"
        >招生运营</span
      >
      / 物料下载
    </div>
    <div class="basicMaterial">
      <div class="main">
        <el-form
          size="mini"
          ref="form"
          :model="course_form"
          label-position="left"
          class="form"
          @submit.native.prevent
        >
          <el-form-item label="使用场景">
            <!-- <el-checkbox style="float:left" class="all" :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox> -->
            <!-- <el-checkbox-group style="margin-left:20px" v-model="course_form.scene_id" @change="handleCheckedChange">
              <el-checkbox v-for="item in sceneList1" :label="item.id" :key="item.id">{{item.name}}</el-checkbox>
            </el-checkbox-group> -->
            <el-radio-group
              @change="handleCheckedChange1"
              v-model="course_form.scene_id"
            >
              <el-radio label="">全部</el-radio>
              <el-radio
                v-for="item of sceneList1"
                :key="item.id"
                :label="item.id"
                >{{ item.name }}</el-radio
              >
            </el-radio-group>
          </el-form-item>

          <el-form-item label="所属科目">
            <el-radio-group
              @change="tchGetTchCurriculum"
              v-model="course_form.subject_id"
            >
              <el-radio label>全部</el-radio>
              <el-radio label="public">公开</el-radio>
              <el-radio
                v-for="item of subjectList"
                :key="item.id"
                :label="item.id"
                >{{ item.name }}</el-radio
              >
            </el-radio-group>
          </el-form-item>

          <el-form-item class="input_left">
            <el-input
              v-model="course_form.title"
              placeholder="请输入物料名称"
              @keyup.enter.native="search"
            ></el-input>

            <el-button type="primary" style="margin-left: 20px" @click="search"
              >搜索</el-button
            >
          </el-form-item>
        </el-form>
        <div v-if="isShow">
          <div class="recommend">当月推荐</div>
          <el-row :gutter="20">
            <el-col :span="6" v-for="item of curriculumList" :key="item.id">
              <div class="video_list">
                <div
                  @click="handleClickCard(item)"
                  class="courses_img"
                  :style="{
                    backgroundImage: 'url(' + item.img_url + ')',
                  }"
                ></div>
                <div class="courses_title">
                  <div style="overflow: hidden">
                    <div class="title_subject">
                      <div class="title_name">{{ item.title }}</div>
                    </div>
                  </div>

                  <div class="title_bottom">
                    <div class="right_bottom">
                      浏览
                      <span class="num">{{ item.tch_num }}</span>

                      <el-tag
                        style="margin-left: 10px"
                        size="mini "
                        v-for="item1 in item.typeNameArr"
                        :key="item1.id"
                      >
                        {{ item1.typeName }}</el-tag
                      >
                    </div>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
          <div style="margin: 20px; text-align: right">
            <el-pagination
              @current-change="handleCurrent"
              :current-page="page_no"
              :page-size="page_size"
              layout="total, prev, pager, next, jumper"
              :total="total"
            ></el-pagination>
          </div>
        </div>
        <!-- 往期物料 -->
        <div class="recommend">往期物料</div>
        <el-row :gutter="20">
          <el-col :span="6" v-for="item of oldList" :key="item.id">
            <div class="video_list">
              <div
                @click="handleClickCard(item)"
                class="courses_img"
                :style="{
                  backgroundImage: 'url(' + item.img_url + ')',
                }"
              ></div>
              <div class="courses_title">
                <div style="overflow: hidden">
                  <div class="title_subject">
                    <div class="title_name">{{ item.title }}</div>
                  </div>
                </div>

                <div class="title_bottom">
                  <div class="right_bottom">
                    浏览
                    <span class="num">{{ item.tch_num }}</span>

                    <el-tag
                      style="float: right; margin-right: 5px"
                      size="mini "
                      v-for="item1 in item.typeNameArr"
                      :key="item1.id"
                    >
                      {{ item1.typeName }}</el-tag
                    >
                  </div>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
        <div style="margin: 20px; text-align: right">
          <el-pagination
            @current-change="handleCurrent1"
            :current-page="page_no1"
            :page-size="page_size1"
            layout="total, prev, pager, next, jumper"
            :total="total1"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { getTchTrainingList } from "@/api/teachingResearchTraining.js";
// import { tchGetTchSubjectAuth } from "@/api/classroom/teacher_api";
import { sceneList, meterialList } from '@/api/operationalActivitiesPc.js'
import { getZoneSchoolSubjectList } from '@/api/community.js'

export default {
  data() {
    return {
      isShow: true,
      checkAll: true, // 全选
      checkGroup: [], // 已经选中的数据
      isIndeterminate: false, // 全选的标记
      checkedKeyLists: [], // key的list数据
      copyLists: [
        {
          name: '测试1',
          id: 1,
        },
        {
          name: '测试2',
          id: 2,
        },
        {
          name: '测试3',
          id: 3,
        },
        {
          name: '测试4',
          id: 4,
        },
        {
          name: '测试5',
          id: 5,
        },
      ], // 选择的列表数据

      // checkAll: false,
      // checkedCities: [],

      // isIndeterminate: true,
      page_size1: 20,
      page_no1: 1,
      total1: 0,
      page_size: 4,
      page_no: 1,
      total: 0,
      course_form: {
        scene_id: '',
        subjectIds: [],
        subject_id: '',
        typeLits_id: '', //物料类型
        title: '',
      },
      tagOldList: [],
      tagList: [
        {
          id: 1,
          tag: '123',
        },
        {
          id: 2,
          tag: '123',
        },
        {
          id: 3,
          tag: '123',
        },
      ],
      curriculumList: [],
      oldList: [],
      arr: [],

      subjectList: [], //所属科目
      typeLits: [], //物料类型
      sceneList1: [], //使用场景
    }
  },
  mounted() {
    this.sceneList()
    this.tchGetTchSubjectAuth()
    this.meterialList()
    this.meterialOldList()

    // this.getinfo();
  },
  methods: {
    // 初始化 checkedKeyLists
    // init() {
    //   this.sceneList1.forEach(el => {
    //     this.checkedKeyLists.push(el.id);
    //     this.course_form.scene_id = this.checkedKeyLists;
    //   });
    // },
    // 全选操作
    handleCheckAllChange(val) {
      this.course_form.scene_id = val ? this.checkedKeyLists : []
      this.isIndeterminate = false
    },
    // 选择操作
    handleCheckedChange(value) {
      let checkedCount = value.length
      this.checkAll = checkedCount === this.sceneList1.length
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.sceneList1.length
      this.course_form.scene_id = value
      console.log(this)
      this.meterialList()
      this.meterialOldList()
    },
    handleCheckedChange1(val) {
      this.arr = []
      console.log(val)

      this.course_form.scene_id = val
      this.sceneList1.map((item) => {
        console.log(item.id, 55555)
        this.arr.push(item.id)
      })

      this.page_no1 = 1
      this.meterialList()
      this.meterialOldList()
    },

    //获取场景列表
    sceneList() {
      sceneList({}).then((res) => {
        this.sceneList1 = res.baseMeterialSceneList
        // this.init();
      })
    },

    handleCheckAllChange1(val) {
      this.sceneList()
      let checked = this.sceneList1.map((item) => {
        return item.id
      })

      this.course_form.scene_id = checked

      this.course_form.scene_id = val ? checked : []
      console.log(this.checkedCities)
      this.isIndeterminate = false
      // console.log(this.isIndeterminate);
    },
    handleCheckedCitiesChange1(val) {
      let checkedCount = val.length
      this.checkAll = checkedCount === this.sceneList1.length
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.sceneList1.length
      console.log(val, 456)
      this.course_form.scene_id = val
      console.log(this)
      this.meterialList()
      this.meterialOldList()
    },

    tchGetTchCurriculum(val) {
      this.course_form.subject_id = val

      this.meterialList()
      this.meterialOldList()
    },

    //搜索
    search() {
      this.page_no1 = 1
      this.meterialList()
      this.meterialOldList()
    },

    tchGetTchSubjectAuth() {
      console.log('查询老师科目权限')
      getZoneSchoolSubjectList().then((res) => {
        this.subjectList = res.subjectList
        console.log('获取老师权限列表')
        console.log(res)

        if (res.subjectList.length == 0) {
          this.$message.warning('无科目权限')
          return
        }
        // this.getinfo()
      })
    },

    //获取列表

    meterialList() {
      meterialList({
        subjectId: this.course_form.subject_id,
        // subjectIds: JSON.stringify(this.course_form.subjectIds),
        sceneIds: this.course_form.scene_id
          ? JSON.stringify([this.course_form.scene_id])
          : JSON.stringify(this.arr),
        title: this.course_form.title,
        page_no_top: this.page_no,
        page_size_top: this.page_size,
      }).then((res) => {
        this.curriculumList = res.topBaseMeterialList
        console.log(this.curriculumList.length, 666666)
        if (this.curriculumList.length <= 0) {
          this.isShow = false
        } else {
          this.isShow = true
        }

        res.topBaseMeterialList.map((item) => {
          this.tagList = item.typeNameArr
          console.log(item.typeNameArr, 555)
        })
        this.total = res.total_top
      })
    },
    //获取往期列表
    meterialOldList() {
      meterialList({
        subjectId: this.course_form.subject_id,
        // subjectIds: JSON.stringify(this.course_form.subjectIds),
        sceneIds: this.course_form.scene_id
          ? JSON.stringify([this.course_form.scene_id])
          : JSON.stringify(this.arr),
        title: this.course_form.title,
        page_no_past: this.page_no1,
        page_size_past: this.page_size1,
      }).then((res) => {
        this.oldList = res.pastBaseMeterialList
        res.pastBaseMeterialList.map((item) => {
          this.tagOldList = item.typeNameArr
        })
        this.total1 = res.total_past

        // this.course_form.scene_id = this.course_form.scene_id.toString()
        // console.log(this.course_form.scene_id.toString(), 56898)
      })
    },

    //
    handleCurrent(val) {
      this.page_no = val
      this.meterialList()
    },
    handleCurrent1(val) {
      this.page_no1 = val
      this.meterialOldList()
    },

    handleClickCard(item) {
      console.log(item)

      console.log('检验校区类型')
      console.log(this.$store.state.user.schoolInfo.isTry)

      if (!this.$store.state.user.schoolInfo.isTry) {
        this.$router.push({
          name: 'basic-material-details',
          query: {
            id: item.id,
            title: item.title,
          },
        })
      } else {
        this.$message.warning('体验账号,暂无权限查看!')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.mainNew {
  height: 100%;
}
.topTitle {
  height: 60px;
  background: #fff;
  margin: 10px;
  padding: 20px;
  border-radius: 5px;
  box-sizing: border-box;
  font-size: 14px;
  span {
    color: rgba(0, 0, 0, 0.45);
  }
}
.num {
  margin-left: 3px;
}
.recommend {
  color: #505050;
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 20px;
}
.basicMaterial {
  width: 100%;
  padding: 10px;
  padding-top: 0;
  box-sizing: border-box;
}
.title {
  width: 100%;
  height: 63px;
  background-color: #fff;
  line-height: 63px;
  color: rgba(0, 0, 0, 1);
  font-size: 16px;
}
.title_left {
  color: rgba(0, 0, 0, 0.45);
  font-size: 16px;
  margin-left: 10px;
}
.main {
  width: 100%;
  height: auto;
  min-height: calc(100vh - 65px);
  background-color: #fff;
  padding: 24px;
  box-sizing: border-box;
  border-radius: 5px;
}
.main .el-input {
  width: 337px;
  height: 30px;
}
.form {
  overflow: hidden;
}
.input_left {
  float: left;
}
.icon_right {
  float: right;
  cursor: pointer;
}
.new {
  position: relative;
  top: 0;
  right: 125px;
}
.top1 {
  position: absolute;
  top: 0px;
  left: 0;
}
.bottom1 {
  position: absolute;
  top: 8px;
  left: 0;
}
.new_txt {
  width: 50px;
  position: absolute;
  left: -25px;
  top: 3px;
}
.hot {
  position: relative;
  top: 0;
  right: 50px;
}
.top2 {
  position: absolute;
  top: 0px;
  left: 0;
}
.bottom2 {
  position: absolute;
  top: 8px;
  left: 0;
}
.hot_txt {
  width: 50px;
  position: absolute;
  left: -25px;
  top: 3px;
}
.video_list {
  border: 1px solid #e4e7ed;
  margin-bottom: 20px;
  border-radius: 5px;
  background: white;
  cursor: pointer;
}
.courses_img {
  height: 0;
  padding-bottom: 69%;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  border-radius: 5px 5px 0px 0px;
  background-color: #ccc;
}
.courses_title {
  flex: 1;
  padding: 10px;
}
.top_tag {
  float: left;
  color: rgb(241, 90, 36);
  font-size: 10px;
  border: 1px solid rgb(241, 90, 36);
  padding: 2px 4px;
  border-radius: 5px;
  margin-right: 10px;
}

.title_subject {
  text-align: left;
  line-height: 26px;
  color: rgba(80, 80, 80, 1);
  font-size: 16px;
  font-weight: bold;

  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
.title_bottom {
  color: rgba(80, 80, 80, 1);
  font-size: 14px;
  overflow: hidden;
  margin-top: 10px;
}
.left_bottom {
  float: left;
}
.right_bottom {
}
/deep/ .el-breadcrumb {
  line-height: 63px;
  padding-left: 20px;
}
.title_name {
  // overflow: hidden; //超出的文本隐藏
  // text-overflow: ellipsis; //溢出用省略号显示
  // display: -webkit-box;
  // -webkit-line-clamp: 1; // 超出多少行
  // -webkit-box-orient: vertical;
  // text-align: left;
}
.all /deep/.el-checkbox__label {
  margin-right: 20px;
}
</style>
